import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/BA';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得指定聯絡人作業申請條款說明
export function getAgreeTermsBA() {
    return get(`${url}/getAgreeTerms`);
}

// 指定聯絡人作業申請條款同意
export function postAgreeBA() {
    return post(`${url}/agree`);
}

/**
 * 保戶進入指定聯絡人作業前，取得先前指定聯絡人作業有效資料
 * @return {Object}
 */
export function getInfoBA() {
    return get(`${url}/info`);
}

// 指定聯絡人作業送出申請
export function submitBA(data) {
    return post(`${url}/submit`, data, {
        ...options,
        errorDialog: false,
    });
}
